import { callFes } from '..';

interface UploadStaticFileRequestBody {
  transactionId: string;
  file: MediaStorageService.Schemas.FilesRequestPost['file'];
  owners?: Array<string>;
}

export const uploadStaticFile = (
  data: UploadStaticFileRequestBody
): Promise<MediaStorageService.Schemas.TransactionFilesResponse> => {
  return callFes.post('upload-static-file', data);
};
